// Simple row layout
import React from 'react';
import { useCopyToClipboard } from 'react-use';
import { type RestOfferCode } from '@bbkAdminUtils/api-client/rest-modals-cards-types';

type Props = {
  offerCode: RestOfferCode;
};
const ModalOfferCode: React.FC<Props> = (props) => {
  const { offerCode } = props;

  const [result, copy] = useCopyToClipboard();
  const copied =
    result.value === offerCode.code &&
    !result.error &&
    result.noUserInteraction;

  return (
    <div className="modal-offer-code">
      <div className="MOCContainer">
        <div className="code">
          <span className="code-text">{offerCode.code}</span>
          <button
            type="button"
            className="code-copy"
            onClick={() => copy(offerCode.code)}
          >
            {copied ? <i>copied</i> : 'copy'}
          </button>
        </div>
        <div className="code-instructions-title">How to redeem:</div>
        <div className="code-instructions">
          {offerCode.how_to.map((ht, i) => (
            <div key={ht}>
              <span className="inst-number">{i + 1}.</span> {ht}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ModalOfferCode;
